"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VSearchSelectFieldAsyncContext = void 0;
var react_1 = require("react");
exports.VSearchSelectFieldAsyncContext = (0, react_1.createContext)({
    refInputSearch: { current: null },
    isOpen: false,
    loading: false,
    options: [],
    selection: '',
    amountCharacterSearch: 3,
    changePopoverView: function () { },
    selectDeselectItem: function () { },
    onSearchData: function () { },
    onClearSearchData: function () { },
    onChangeFirstLoad: function () { }
});
